import { Card } from '../card/Card'
import s from './PermissionNotice.module.scss'

/**
 * Die Meldung, wenn das Recht für eine Ansicht fehlt.
 *
 * Bewusst keine leere Liste: Die wäre von "es gibt nichts" nicht zu
 * unterscheiden, und der Angemeldete würde die Daten suchen, statt Bescheid zu
 * bekommen.
 *
 * Das fehlende Recht steht klein darunter. Nach außen wäre das eine Auskunft
 * über den inneren Aufbau — hier ist es der Satz, den der Angemeldete an die
 * Administration weitergibt, damit dort niemand raten muss.
 */
export function PermissionNotice({ permission, subject }: {
  permission: string
  /** Worum es geht, im Akkusativ: "die Instrumente". */
  subject: string
}) {
  return (
    <Card span={12}>
      <div className={s.notice}>
        <span className={s.mark} aria-hidden="true">!</span>
        <span className={s.title}>Kein Zugriff auf {subject}</span>
        <span className={s.text}>
          Deinem Konto fehlt die Berechtigung, {subject} zu sehen. Wende Dich an
          die Administration, wenn Du sie brauchst.
        </span>
        <span className={s.detail}>{permission}</span>
      </div>
    </Card>
  )
}
